export default {
  placement: 'START-APPLICATION',
  tagMaropost: 'Start Application',
  chatInteractionId: 62815,
  product: 'STM'
}
